<ion-header *ngIf="showHeader">
    <ion-toolbar>
        <ion-title>{{'MyContacts' | translate}}</ion-title>
    </ion-toolbar>
</ion-header>

<div class="main">

    <ion-card *ngFor="let contact of contacts">
        <ion-item>
            <ion-avatar slot="start">
                <img alt="avatar" src="/assets/img/avatar.png">
            </ion-avatar>
            <ion-label>
                <h1>{{contact.firstname}}</h1>
                <h1>{{contact.lastname}}</h1>
            </ion-label>
        </ion-item>

        <ion-row>
            <ion-col class="ion-text-center ion-align-self-center">
                <ion-button (click)="startCall(contact)" fill="clear"  size="small">
                    <ion-icon slot="start" name="call"></ion-icon>
                    <div>{{'Call' | translate}}</div>
                </ion-button>
            </ion-col>
            <ion-col class="ion-text-center ion-align-self-center">
                <ion-button (click)="startVideoCall(contact)" fill="clear" size="small">
                    <ion-icon slot="start" name="videocam"></ion-icon>
                    <div>{{'VideoCall' | translate}}</div>
                </ion-button>
            </ion-col>
            <ion-col (click)="startChat(contact)" class="ion-text-center ion-align-self-center">
                <ion-button fill="clear"  size="small">
                    <ion-icon slot="start" name="chatbubbles"></ion-icon>
                    <div>{{'Chat' | translate}}</div>
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-card>


</div>
